export class Coords {
    static get(options) {
        var options = options || {}; //elem, editor
        const elem = options.element || null;
        const editor = options.editor || null;
        const win = options.window || (editor && editor.getWin()) || window;
        const doc = options.document || (editor && editor.getDoc()) || document;
        const body = options.body || (editor && editor.getBody()) || document.body;

        const eb = elem.getBoundingClientRect();
        const scrollTop = win.pageYOffset || doc.documentElement.scrollTop || (body && body.scrollTop);
        const scrollLeft = win.pageXOffset || doc.documentElement.scrollLeft || (body && body.scrollLeft);
        return {
            top: eb.top + scrollTop,
            left: eb.left + scrollLeft,
            bottom: eb.bottom + scrollTop,
            right: eb.right + scrollLeft
        };
    }
}
